// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// // import Pagination from '@components/Shared/Pagination/Pagination';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import useGetInvMoveList from '@hooks/INV/InvMove/useGetInvMoveList';
// import NtxTable from '@components/DataTable/NtxTable';
// import Loading from '@components/Shared/Loader/Loading';
// import NeatixModal from '@components/Modal/NeatixModal';
// import ListPrint from '@components/Print/ListPrint';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';

// const Index = () => {
//   const { HasPermission } = usePermissions();
//   const [transItem, setTransItem] = useState<any>();
//   const [show, setShow] = useState(false);

//   const { t, i18n } = useTranslation();

//   const Navigate = useNavigate()

//   const { InvMoveList, error, loading } = useGetInvMoveList();

//   //________________________________
//   const columns = [
//     { title: t('Number'), key: 'num' },
//     { title: t('Date'), key: 'date' },
//     { title: t('TransType'), key: 'type' },
//     { title: t(''), key: 'action', className: 'text-end', sortable: false }
//   ];

//   const tableData = InvMoveList?.map((item: any) => {
//     let rowClass;

//     // تحديد لون الشارة بناءً على نوع التحويل
//     const transactionTypeBadge =
//       item.transactionTypeName === 'Internal Move Order' ? (
//         <span className='badge bg-success bg-opacity-3'>
//           <i className='fas fa-exchange-alt me-1'></i> {t('أمر تحويل داخلي')}
//         </span>
//       ) : (
//         <span className='badge bg-danger'>
//           <i className='fas fa-external-link-alt me-1'></i> {t('أمر تحويـل')}
//         </span>
//       );

//     return {
//       num: item.code,
//       date: item.transactionDate?.split('T')[0],
//       type: transactionTypeBadge,

//       action: (
//         <>
//         {/*  INVEditInvMove عند إنشاء مكون التعديل لا تنسى صلاحية التعديل */}
//           {HasPermission('INVViewInvMoveDetails') && (
//             <button
//               type='button'
//               className='btn btn-sm btn-outline-theme me-1'
//               onClick={() => Navigate(`${item.id}/UpdateInvMove`)}
//             >
//               <i className='far fa-lg   fa-fw fa-edit'></i>
//             </button>
//           )}

//           <button
//             type='button'
//             className='btn btn-sm btn-outline-secondary me-1'
//             onClick={() => {
//               setTransItem(item);
//               setShow(true);
//             }}
//           >
//             <i className='fas fa-lg fa-fw fa-print'></i>
//           </button>

//           {HasPermission('INVEditInvMove') && (
//             <button type='button' className='btn btn-sm btn-outline-danger me-1'>
//               <i className='far fa-lg fa-fw fa-trash-alt'></i>
//             </button>
//           )}
//         </>
//       )
//     };
//   });

//   //________________________________

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//              link: ':moduleHome'
//             },
//             {
//               name: 'أوامر التحويـــل ',
//               link: null
//             }
//           ]}
//           PageName='أوامر  التحويــــل'
//         />

//         <div className='ms-auto'>
//           {HasPermission('INVAddInvMove') && (
//             <Link to='AddInvMove' className='btn me-1 btn-theme'>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('أمر تحويـل جديد')}
//             </Link>
//           )}
//         </div>
//       </div>

//       <Card>
//         <Loading loading={loading}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal show={show} setShow={setShow} size='sm' showHeader={false} centered bodyClassName='p-0'>
//         <Card>
//           <CardBody>
//             {transItem && (
//               <>
//                 <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>{transItem?.code}</div>
//                 <ListPrint ReferenceId={transItem.id} PrintTemplateTypeId='0324A2CD-561F-4E6E-8C38-F38E3C4FA56A' />
//               </>
//             )}
//             <button
//               type='button'
//               className='btn btn-lg btn-default rounded-1 w-100 mt-3'
//               onClick={() => setShow(false)}
//             >
//               <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//             </button>
//           </CardBody>
//         </Card>
//       </NeatixModal>
//     </div>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import Select from 'react-select';

import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

import ListPrint from '@components/Print/ListPrint';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

// ✅ عدّل الهوك لو عندكم هوك خاص بالتحويلات
import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';

const TABLE_KEY = 'InvMove_Index';

// ✅ ضع Template Id الصحيح لطباعة أوامر التحويل
const PRINT_TEMPLATE_ID = 'PUT-MOVE-ORDER-PRINT-TEMPLATE-GUID-HERE';

const Index = () => {
  const { t, i18n } = useTranslation();
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInventoryOptions } = useGetInventoryWithPermission();

  // ===========================
  // DynamicTable state
  // ===========================
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ===========================
  // Local filters (مثل InvReceive)
  // ===========================
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [inventoryFilter, setInventoryFilter] = useState<any>(null);
  const [transTypeFilter, setTransTypeFilter] = useState<any>(null);
  const [postedFilter, setPostedFilter] = useState<any>(null);

  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // ===========================
  // Print modal
  // ===========================
  const [showPrint, setShowPrint] = useState(false);
  const [transItem, setTransItem] = useState<any>(null);

  // ===========================
  // Options
  // ===========================
  const { OptionsTransactionTypes, loading: loadingTransTypes } = useGetTransactionTypesReceiveList();

  const postedOptions = [
    { value: true, label: t('Posted') },
    { value: false, label: t('NotPosted') }
  ];

  // ===========================
  // Init table
  // ===========================
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'InvMove/GeList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ===========================
  // Helpers
  // ===========================
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const getOptionValue = (opt: any) => opt?.value ?? opt?.id ?? opt?.transTypeId ?? opt?.branchId ?? opt?.inventoryId;

  const safeDate = (dt: string) => (dt ? dt.split('T')[0] : '—');

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  const getTransactionBadge = (transactionType: string) => {
    const type = (transactionType || '').trim();

    switch (type) {
      case 'Move Order':
      case 'Move Order Receipt':
      case 'Move Order Issue':
      case 'امر تحويل':
      case 'أمر تحويل':
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-exchange-alt me-1'></i> {t('MOV') || 'أمر تحويل'}
          </span>
        );

      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-question-circle me-1'></i> {type || t('Unknown')}
          </span>
        );
    }
  };

  // ===========================
  // Apply/Clear filters
  // ===========================
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (branchFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'branchId',
        operator: 0,
        value: getOptionValue(branchFilter)
      });
    }

    if (inventoryFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'inventoryId', // ✅ المخزن (من)
        operator: 0,
        value: getOptionValue(inventoryFilter)
      });
    }

    if (transTypeFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionTypeId',
        operator: 0,
        value: getOptionValue(transTypeFilter)
      });
    }

    if (postedFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'postedFlag',
        operator: 0,
        value: postedFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 3,
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 5,
        value: dateTo
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const clearFilters = () => {
    setBranchFilter(null);
    setInventoryFilter(null);
    setTransTypeFilter(null);
    setPostedFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ===========================
  // DynamicFilter fields (السلايدر)
  // ===========================
  const fields: any = [
    { name: 'code', label: t('Code'), type: 'string' },
    { name: 'transactionDate', label: t('TransactionDate'), type: 'date' },
    {
      name: 'postedFlag',
      label: t('PostingStatus'),
      type: 'options',
      options: postedOptions
    },
    { name: 'referenceCode', label: t('ReferenceNumber'), type: 'string' },
    {
      name: 'transactionTypeId',
      label: t('TransType'),
      type: 'options',
      options: OptionsTransactionTypes || []
    },

    // ✅ من
    { name: 'branchId', label: t('OperationUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'inventoryId', label: t('Inventory'), type: 'options', options: InventoryOptions },

    // ✅ إلى (للعمود الجديد + السلايدر)
    {
      name: 'branchTo',
      label: t('ToOperationUnit') || 'إلى وحدة التشغيل',
      type: 'options',
      options: OperatingUnitOptions
    },
    { name: 'inventoryTo', label: t('ToInventory') || 'إلى المخزن', type: 'options', options: InventoryOptions }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: 'أوامر التحويل', link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={'أوامر التحويل'} />

        <div className='ms-auto'>
          {HasPermission('INVAddInvMove') && (
            <Link to='AddInvMove' className='btn btn-theme'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('أمر تحويـل جديد')}
            </Link>
          )}
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ وحدة التشغيل (من) */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  isLoading={loadingOperatingUnitOptions}
                  value={branchFilter}
                  onChange={setBranchFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('OperationUnit')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ المخزن (من) */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-warehouse'></i>
                </span>
                <Select
                  isLoading={loadingInventoryOptions}
                  value={inventoryFilter}
                  onChange={setInventoryFilter}
                  options={InventoryOptions}
                  placeholder={t('Inventory')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ نوع الحركة */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-layer-group'></i>
                </span>
                <Select
                  value={transTypeFilter}
                  onChange={setTransTypeFilter}
                  options={OptionsTransactionTypes}
                  isLoading={loadingTransTypes}
                  placeholder={t('TransType')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ Date From-To */}
            <div className='col-lg-6'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                />
                <span className='input-group-text'>-</span>
                <input type='date' className='form-control' value={dateTo} onChange={e => setDateTo(e.target.value)} />
              </div>
            </div>

            {/* ✅ Buttons */}
            <div className='col-lg-6 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !branchFilter && !inventoryFilter && !transTypeFilter && !postedFilter && !dateFrom && !dateTo
                }
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>
                    {t('Code')} / {t('TransactionDate')}
                  </th>

                  <th className='small'>
                     {t('TransType')}
                  </th>

                  <th className='small'>
                    {t('OperationUnit')} / {t('Inventory')}
                  </th>

                  {/* ✅ العمود الإضافي المطلوب */}
                  <th className='small'>
                    {'إلى وحدة التشغيل'} / {'إلى المخزن'}
                  </th>

                  {/* <th className='small text-center'>{t('PostingStatus')}</th> */}
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const transTypeName =
                      i18n.language === 'en'
                        ? item.transactionTypeName
                        : item.transactionTypeName2 || item.transactionTypeName;

                    // ✅ من
                    const branchName = i18n.language === 'en' ? item.branchName : item.branchName2 || item.branchName;
                    const invName = i18n.language === 'en' ? item.inventory : item.inventory2 || item.inventory;

                    // ✅ إلى (افتراض أسماء الحقول)
                    const branchToName =
                      i18n.language === 'en' ? item.branchToName : item.branchToName2 || item.branchToName; // قد تكون null
                    const invToName =
                      i18n.language === 'en' ? item.inventoryToName : item.inventoryToName2 || item.inventoryToName; // قد تكون null

                    return (
                      <tr key={item.id}>
                        {/* رقم + تاريخ */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <div className='fw-bold text-theme' style={{ letterSpacing: '0.05em' }}>
                              {item.code}
                            </div>
                            <small className='text-muted'>
                              <i className='fas fa-calendar-alt me-1'></i>
                              {safeDate(item.transactionDate)}
                            </small>
                          </div>
                        </td>

                        {/* المرجع + نوع */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column gap-1'>
                            <div>
                              {/* {item.referenceCode ? (
                                <span className='badge bg-secondary bg-opacity-35 text-body' title={item.referenceCode}>
                                  <i className='fas fa-hashtag me-1'></i>
                                  {item.referenceCode}
                                </span>
                              ) : (
                                <span className='text-muted'>—</span>
                              )} */}
                            </div>
                            <div>{getTransactionBadge(transTypeName)}</div>
                          </div>
                        </td>

                        {/* من: وحدة تشغيل + مخزن */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <div className='fw-bold'>
                              <i className='fas fa-building me-1'></i>
                              {branchName || '—'}
                            </div>
                            <small className='text-muted mt-1'>
                              <i className='fas fa-warehouse me-1'></i>
                              {invName || '—'}
                            </small>
                          </div>
                        </td>

                        {/* ✅ إلى: وحدة تشغيل + مخزن */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <div className='fw-bold'>
                              <i className='fas fa-building me-1'></i>
                              {branchToName || <span className='text-muted'>—</span>}
                            </div>
                            <small className='text-muted mt-1'>
                              <i className='fas fa-warehouse me-1'></i>
                              {invToName || '—'}
                            </small>
                          </div>
                        </td>

                        {/* الترحيل */}
                        {/* <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td> */}

                        {/* الإجراءات */}
                        <td className='align-middle text-end'>
                          <div className='d-flex justify-content-end gap-2'>
                            {HasPermission('INVViewInvMoveDetails') && (
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-theme'
                                title={t('ViewDetails')}
                                onClick={() => Navigate(`${item.id}/UpdateInvMove`)}
                              >
                                <i className='bi bi-info-circle fa-lg me-1'></i>
                                {t('ViewDetails')}
                              </button>
                            )}

                            <button
                              type='button'
                              className='btn btn-sm btn-outline-secondary'
                              title={t('Print')}
                              onClick={() => {
                                setTransItem(item);
                                setShowPrint(true);
                              }}
                            >
                              <i className='fas fa-print fa-fw'></i>
                            </button>

                            {HasPermission('INVEditInvMove') && (
                              <button type='button' className='btn btn-sm btn-outline-danger' title={t('Delete')}>
                                <i className='far fa-trash-alt fa-fw'></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-5 text-muted'>
                      <div className='py-4'>
                        <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h5 className='mb-2'>{activeFiltersCount > 0 ? t('NoSearchResults') : t('NoData')}</h5>
                        <p className='text-muted small'>
                          {activeFiltersCount > 0 ? 'جرّب تقليل الفلاتر أو تغيير التاريخ' : 'لا توجد أوامر تحويل مسجلة'}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      {/* ✅ Print Modal */}
      <NeatixModal show={showPrint} setShow={setShowPrint} size='sm' showHeader={false} centered bodyClassName='p-0'>
        <Card>
          <div className='p-3'>
            {transItem && (
              <>
                <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>{transItem?.code}</div>
                <ListPrint ReferenceId={transItem.id} PrintTemplateTypeId={PRINT_TEMPLATE_ID} />
              </>
            )}

            <button
              type='button'
              className='btn btn-lg btn-default rounded-1 w-100 mt-3'
              onClick={() => setShowPrint(false)}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </Card>
      </NeatixModal>
    </>
  );
};

export default Index;
